// extracted by mini-css-extract-plugin
export default {"container":"PokemonType_container__p0054"};